// extracted by mini-css-extract-plugin
export default {"card":"IngredientsCategory_card__X5w2a","link":"IngredientsCategory_link__eA3js"};